<template lang="pug">
.box
    b-modal(
        v-model="showSendOwnerSettlementModal",
        has-modal-card,
        full-screen,
        destroy-on-hide
        trap-focus,
        aria-role="dialog",
        aria-modal)
        template(#default="props")
            SendOwnerSettlementModal(:data="selectedOwners.map(o => ({...o, firstName: '', lastName: _generateOwnerName(o), ...formData}))", :year="formData.year", :month="formData.month", @close="refresh()")
    b-modal(
        v-model="showBookingsWithOpenPayments",
        has-modal-card,
        trap-focus,
        :full-screen="false",
        :can-cancel="true")
        .modal-card(style="width: auto")
            header.modal-card-head
                p.modal-card-title Verträge mit offenen Zahlungen
            section.modal-card-body
                b-table(:data="bookingsWithOpenPayments", default-sort-direction="asc")
                    b-table-column(field="bookingStatus.name", label="Status", v-slot="props")
                        | {{ props.row.bookingStatus.name }}
                    b-table-column(field="rentObject.name", label="Name", v-slot="props")
                        | {{ props.row.rentObject.name }}
                    b-table-column(label="Zeitraum", v-slot="props")
                        | {{ new Date(props.row.startDate).toLocaleDateString("de-DE", dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString("de-DE", dateOptions) }}
                    b-table-column(label="Aktionen", v-slot="props")
                        .button-wrapper
                            b-button(
                                type="is-secondary",
                                icon-left="refresh"
                                @click="checkOpenPaymentsAgain(props.row.id)")
                            b-button(
                                type="is-primary",
                                @click="jumpToBooking(props.row)") Öffnen

    .label Zeitraum auswählen
    b-field.margin-top(grouped)
        b-field(label='Monat' label-position='on-border')
            b-select(placeholder='Monat auswählen' v-model="formData.month")
                option(value='0') Januar
                option(value='1') Februar
                option(value='2') März
                option(value='3') April
                option(value='4') Mai
                option(value='5') Juni
                option(value='6') Juli
                option(value='7') August
                option(value='8') September
                option(value='9') Oktober
                option(value='10') November
                option(value='11') Dezember

        b-field(label='Jahr' label-position='on-border')
            b-select(placeholder='Jahr auswählen' v-model="formData.year")
                option(v-for="y in currentYear-rootYear") {{rootYear + y}}

    .label.margin-top Eigentümer auswählen
    b-message(type="is-warning" v-if="formData.month === null || formData.year === null") {{formData.month}} {{formData.year}} Bitte wählen Sie zuerst einen Zeitraum aus.
    b-table(v-else :data="owners"
        default-sort-direction="asc"
        :checked-rows.sync="selectedOwners"
        :is-row-checkable="(row) => !(row.bookingsForSettlementCount === 0 && row.bookingsForSettlementWithPastCount === 0 && row.financeInvoicesForSettlement === 0)"
        checkable)
        b-table-column(field='fullName' label='Eigentümer' sortable v-slot="props")
            | {{ props.row.fullName }}
        b-table-column(field='rentObjectCount' label='Objektanzahl' sortable v-slot="props")
            | {{ props.row.rentObjectCount }}
        b-table-column(field='' :label='`Verträge im ${monthNames[formData.month]}`' sortable v-slot="props")
            | {{ props.row.bookingsForSettlementCount }}
        b-table-column(field='' :label='`Verträge in der Vergangenheit`' sortable v-slot="props")
            | {{ props.row.bookingsForSettlementWithPastCount }}
        b-table-column(field='' :label='`Rechnungen`' sortable v-slot="props")
            | {{ props.row.financeInvoicesForSettlement }}
        b-table-column(field='' label='Verträge mit offenen Zahlungen' sortable v-slot="props")
            b-button(type="is-text" @click.stop="bookingsWithOpenPayments = props.row.bookingsWithOpenPayments") {{ props.row.bookingsWithOpenPaymentsCount }}

    .button-wrapper.margin-top.right
        //- b-button(type="is-light", @click="") Abbrechen
        b-button(type="is-primary", @click="openSettlementModal") Abrechnungsvorschau
</template>

<script>
import SendOwnerSettlementModal from '@/components/molecules/SendOwnerSettlementModal.vue';
import { generateOwnerName } from '@/store/modules/emailTemplates.js';

export default {
    components: {
        SendOwnerSettlementModal,
    },
    props: {
        earliestStartDate: {
            type: Date
        },
    },
    watch: {
        bookingsWithOpenPayments() {
            this.showBookingsWithOpenPayments = true;
        },
        formData: {
            handler() {
                this.selectedOwners = [];
                this.getSettlementStatistic();
            },
            deep: true
        }
    },
    data() {
        return {
            owners: [],
            bookingsWithOpenPayments: [],
            showSendOwnerSettlementModal: false,
            showBookingsWithOpenPayments: false,
            selectedOwners: [],
            year: new Date().getFullYear(),
            rootYear: new Date(this.earliestStartDate).getFullYear() - 2,
            currentYear: new Date().getFullYear(),
            formData: {
                month: new Date().getMonth(),
                year: new Date().getFullYear(),
            },
            monthNames: [
                'Januar',
                'Februar',
                'März',
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
            ],
            dateOptions: {
                year: "2-digit",
                month: "2-digit",
                day: "2-digit"
            },
        };
    },
    methods: {
        openSettlementModal() {
            if (this.selectedOwners.length > 0) {
                this.showSendOwnerSettlementModal = true
            } else {
                alert("Es wurden bisher keine Eigentümer ausgewählt.");
            }
        },
        toCurrency(value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2
            });
            return formatter.format(value);
        },
        async getSettlementStatistic() {
            const loadingComponent = this.$buefy.loading.open();
            this.owners = await this.$store.dispatch("owners/findAllWithSettlementStatistic", this.formData);
            loadingComponent.close();
        },
        jumpToBooking(booking) {
            this.$router.push({ name: 'Booking', params: { id: booking.id } });
        },
        async checkOpenPaymentsAgain(rentObjectBookingId) {
            const result = await this.$store.dispatch("rentObjectBookings/checkOpenPaymentsAgain", { id: rentObjectBookingId });
            if (result === false) {
                alert("Für die Buchung liegt kein Vertrag oder finale Stornorechnung vor. Bitte ändere den Status der Buchung.");
            } else if (result === 0) {
                alert("Zahlung konnte im System genullt werden. Yeah!");
                this.getSettlementStatistic();
            } else {
                alert(`Zahlung konnte im System genullt werden. Es sind noch ${this.toCurrency(result / 100)} offen.`);
            }
        },
        _generateOwnerName(name) {
            return generateOwnerName(name);
        },
        refresh() {
            this.selectedOwners = [];
            this.showSendOwnerSettlementModal = false;
            this.getSettlementStatistic();
        }
    },
    mounted() {
        this.getSettlementStatistic();
    }
}
</script>

<style lang="scss" scoped>

</style>